import { TransactionStateName } from '@frontend/transaction/types';
import { useEffect, useState } from 'react';

import { TransactionStateBadgeProps } from './transaction-state-badge.component';

interface ViewProps {
    state: VALID_TRANSACTION_STATES | null;
}

const useTransactionStateBadge = (props: TransactionStateBadgeProps): ViewProps => {
    const [state, setState] = useState<VALID_TRANSACTION_STATES | null>(null);

    useEffect(() => {
        switch (props.transactionState) {
            case TransactionStateName.TRANSACTION_CREATED:
                setState(VALID_TRANSACTION_STATES.DRAFT);
                break;
            case TransactionStateName.TRANSACTION_DROP_OFF_PENDING:
                setState(VALID_TRANSACTION_STATES.DROP);
                break;
            case TransactionStateName.TRANSACTION_PICK_UP_PENDING:
                setState(VALID_TRANSACTION_STATES.PICK);
                break;
            case TransactionStateName.TRANSACTION_COMPLETED:
            case TransactionStateName.TRANSACTION_COMPLETED_WITH_FAILURES:
                setState(VALID_TRANSACTION_STATES.COMPLETED);
                break;
            default:
                setState(VALID_TRANSACTION_STATES.NONE);
                break;
        }
    }, [props.transactionState]);

    return {
        state
    };
};

export default useTransactionStateBadge;

export enum VALID_TRANSACTION_STATES {
    DRAFT,
    DROP,
    PICK,
    COMPLETED,
    NONE
}
